module.exports = __webpack_public_path__ + "static/media/textImage.0f5da1f7.svg";